import { Icon } from "@msuite/ui/icons";
import { Timeline } from "@msuite/ui/timeline";
import type { IncomingInvoiceEventList } from "@msuite/utils/types";
import { IncomingInvoiceTimelineItem } from "./incoming-invoice-timeline-item";
import { EVENT_MARKER } from "./timeline-event-labels";
import { toTimelineSections } from "./to-timeline-sections";

/** Props Interface */
interface IncomingInvoiceTimelineProps {
	events: IncomingInvoiceEventList;
	isLoading: boolean;
	refetch: () => Promise<void>;
}

/** Everything that happened to the invoice, newest first, a day per section. */
export function IncomingInvoiceTimeline({
	events,
	isLoading,
	refetch,
}: IncomingInvoiceTimelineProps) {
	/** Render */
	return (
		<Timeline
			timeline={toTimelineSections(events)}
			isLoading={isLoading}
			refetch={refetch}
			renderItem={(_, event) => (
				<IncomingInvoiceTimelineItem
					key={event.id}
					event={event}
				/>
			)}
			renderItemMarker={(type) => (
				<Icon
					name={EVENT_MARKER[type].icon}
					stroke={`var(--color-${EVENT_MARKER[type].color}-500)`}
				/>
			)}
		/>
	);
}
